import { useCallback, useEffect, useState } from "react";
import { api } from "@/lib/api";

export const useFetch = (url) => {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const reload = useCallback(() => {
    api.get(url).then((r) => setData(r.data)).catch((e) => setError(e));
  }, [url]);
  useEffect(() => { reload(); }, [reload]);
  return { data, error, reload };
};
